<template>
    <section class="pb-5">
      <div class="container">
        <div class="row mb-5">
          <div class="col d-flex align-items-center">
            <div class="d-inline-block p-3 p-md-4 rounded-circle bg-primary-alt">
              <img src="assets/img/icons/theme/general/settings-1.svg" alt="Confirmation Icon" class="icon bg-primary" data-inject-svg="data-inject-svg">
            </div>
            <div class="ml-4">
              <h1 class="mb-2">Cara Kerja</h1>
              <div class="lead">Manage your profile, billing, and notification preferences.</div>
            </div>
          </div>
        </div>
      </div>
    </section>
    
</template>

<script>
export default {
    name: 'CaraKerja'
}
</script>